const meeting = {
  path: 'meeting/:courseId',
  component: resolve => require(['../../../pages/teacher/meeting'], resolve),
  props: true
}

export default meeting



// WEBPACK FOOTER //
// ./src/router/teacher/meeting/index.js